import { Injectable } from '@angular/core';
import { NotificationCreate, NotificationEntity } from '@models';
import { BaseApi } from './_base-api';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationApiService extends BaseApi<NotificationEntity, NotificationCreate> {
  constructor() {
    super('/AdminPanel/PushNotification', {
      get: '/AdminPanel/GetPushNotifications',
      post: '/AdminPanel/SendPushNotification',
    });
  }
}
